import { useCallback, useState } from 'react';
import type { DataAttributes } from 'shared/lib/data-auto-test';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { Textarea } from 'shared/ui/Textarea';
import { isNull } from 'shared/lib/type-guards';

let textarea: HTMLTextAreaElement | null;

interface ZipInputProps {
  collapseHeight: number;
  textAreaName: string;
  className?: string;
  attributes?: DataAttributes['attributes'];
  isLightPlaceholder?: boolean;
}

export function ZipInput({ collapseHeight, className, textAreaName, attributes, isLightPlaceholder }: ZipInputProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const ref = useCallback((node: HTMLDivElement | null) => {
    if (!isNull(node)) {
      textarea = node.querySelector('textarea');
      if (textarea) {
        textarea.style.minHeight = `${collapseHeight}px`;
      }
    }
  }, []);

  const isTextOverflowed = () => {
    if (textarea) {
      const scrollHeight = textarea.scrollHeight;
      const offsetHeight = textarea.offsetHeight;

      return scrollHeight > offsetHeight || collapseHeight < offsetHeight;
    }

    return false;
  };

  return (
    <div
      className={className}
      ref={ref}
    >
      <Textarea
        className={isExpanded ? 'h-160' : `h-[${collapseHeight}px]`}
        placeholder="Enter your list of ZIP codes"
        name={textAreaName}
        attributes={attributes}
        isLightPlaceholder={isLightPlaceholder}
      />
      {isTextOverflowed() && (
        <div className="mt-4 flex items-center justify-center">
          <div
            className="flex cursor-pointer select-none items-center"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <span className="text-sm">{isExpanded ? 'Collapse' : 'Expand'}</span>
            <MaterialIcon className="ml-1 text-sm">{isExpanded ? 'expand_less' : 'expand_more'}</MaterialIcon>
          </div>
        </div>
      )}
    </div>
  );
}
